module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_7_2.cd2e9b61.jpeg";